// @flow
import React from 'react'
import { Provider, Store } from 'react-redux'
import PropTypes from 'prop-types'
import { 
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';

import ScrollToTop from './common/components/app/ScrollToTop';
import App from './App'

const Root = ({ store }: { store:Store }) => (
    <Provider store={store}>
      <Router>
        <ScrollToTop>
          <Route path="/" component={App} />
        </ScrollToTop>
      </Router>
    </Provider>
);

Root.propTypes = {
  store: PropTypes.object.isRequired,
};

export default Root;



// WEBPACK FOOTER //
// ./src/modules/Root.js